import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    pagination: {
      page: 0,
      pageSize: 10,
    },
    search: "",
    fullName: "",
    country: { value: "", label: "" },
    city: { value: "", label: "" },
    talentPool: { value: "", label: "" },
    jobsCompleted: "",
    workedWith: "",
    backgroundCheck: "",
    certifications: { value: "", label: "" },
    equipment: { value: "", label: "" },
    skillSet: { value: "", label: "" },
  },
};

const talentPoolFiltersSlice = createSlice({
  name: "talentPoolFiltersSlice",
  initialState,
  reducers: {
    setTalentPoolFilters: (state, action) => {
      const { filterName, data } = action.payload;
      if (filterName === "pagination") {
        state.value.pagination = { ...state.value.pagination, ...data };
      } else {
        state.value[filterName] = data;
      }
    },
    resetTalentPoolFilters: (state) => {
      state.value = { ...initialState.value };
    },
    resetTalentPoolPagination: (state) => {
      state.value.pagination = { page: 0, pageSize: 10 };
    },
  },
});

export const {
  setTalentPoolFilters,
  resetTalentPoolFilters,
  resetTalentPoolPagination,
} = talentPoolFiltersSlice.actions;

export default talentPoolFiltersSlice.reducer;
